module.exports = __webpack_public_path__ + "static/img/chance.f632ee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s31/chance.png
// module id = +gPB
// module chunks = 2